<form (ngSubmit)="createStripeToken()" class="checkout">
  <label class="sr-only" for="card-info">Card Info</label>
  <div id="form-field">
    <input
      [ngClass]="{'invalid-input': customPaymentDataForm.controls.nameOnCard.invalid}"
      class="form-control form-control-lg mb-3"
      placeholder="Name on card"
      id="name-on-card"
      type="text"
      #nameOnCard
      maxlength="50"
      [formControl]="customPaymentDataForm.controls.nameOnCard"
      >
    <div class="form-control form-control-lg pt-3" id="card-info" #cardInfo></div>
    <button id="submit-button" type="submit" class="btn btn-block btn-primary btn-lg" [disabled]="loading || !isAgreedToUserAgreement">
      Subscribe
    </button>
    @if (cardError) {
      <div id="card-errors" role="alert">
        {{ cardError }}
      </div>
    }
  </div>
</form>
